import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalService } from '../core/services/global.service';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  constructor(private global: GlobalService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.global.Token;
    const env = this.global.url_MOBILEPAY
    // const env = 'http://10.25.255.38'

    let req = request;
    if (token) {
      if (req.url.startsWith(env)) {
        const Token = 'nsdfjkfndsjkfnjksdnfjksndjkf8';
        req = request.clone({
          headers: request.headers.set('Authorization', `Token ${Token}`),
        });
        return next.handle(req);
      }
      req = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
      });
    }
    return next.handle(req);
  }
}
